<script lang="ts">
  let {
    type = "text",
    value = $bindable(""),
    placeholder = "",
    disabled = false,
    error = "",
    maxlength = undefined,
    autofocus = false,
    inputmode = undefined,
    class: cls = "",
    onchange,
    oninput,
    onblur,
  }: {
    type?: "text" | "email" | "password" | "number" | "tel" | "url" | "search";
    value?: string;
    placeholder?: string;
    disabled?: boolean;
    error?: string;
    maxlength?: number;
    autofocus?: boolean;
    inputmode?: "numeric" | "email" | "tel" | "url" | "search" | "none" | "text" | "decimal";
    class?: string;
    onchange?: (e: Event) => void;
    oninput?: (e: Event) => void;
    onblur?: (e: FocusEvent) => void;
  } = $props();
</script>

<!-- svelte-ignore a11y_autofocus -->
<input
  {type}
  bind:value
  {placeholder}
  {disabled}
  {maxlength}
  {autofocus}
  {inputmode}
  class="w-full h-11 rounded-xl bg-white/5 border px-3 text-[16px] text-white placeholder-gray-500
    transition-colors outline-none
    focus:border-teal-400 focus:ring-2 focus:ring-teal-400/10
    disabled:opacity-40 disabled:cursor-not-allowed
    {error ? 'border-red-500 ring-2 ring-red-500/10' : 'border-white/10'}
    {cls}"
  {onchange}
  {oninput}
  {onblur}
/>
